import script from "./group-meeting-form-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./group-meeting-form-section.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__